import moment from 'moment';
import cronstrue from 'cronstrue';
import { ChangeAttributeValue } from '@/shared/helpers/api/types/entities.ts';

export function truncate(text: string | null, length: number, clamp?: string) {
    text = text ?? '';

    if (length === 0) return text;

    clamp = clamp || '...';
    length = length || 30;

    if (text.length <= length) return text;

    let tcText = text.slice(0, length - clamp.length);
    let last = tcText.length - 1;

    while (last > 0 && tcText[last] !== ' ' && tcText[last] !== clamp[0]) last -= 1;

    // Fix for case when text dont have any `space`
    last = last || length - clamp.length;

    tcText = tcText.slice(0, last);

    return tcText + clamp;
}

export function shortDate(date: string | Date | null) {
    if (!date) {
        return ';';
    } else if (!moment(date).isValid()) {
        return date;
    } else {
        return moment(date).format('YYYY-MM-DD');
    }
}

export function longDate(date: string | Date | null) {
    if (!date)
        return '';
    return moment(date).format('YYYY-MM-DD HH:mm:ss');
}

export function formatNumber(n: string | number) {
    return n.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
}

export function formatBigNumber(n: number) {
    if (n < 10_000)
        return formatNumber(n);
    if (n < 1_000_000)
        return `${Math.floor(n / 1_000)}k`;
    if (n < 10_000_000)
        return `${formatNumber(Math.floor(n / 1_000))}k`;
    return `${Math.floor(n / 1_000_000)}M`;
}

export function explainCrontabSchedule(cronstrueExpression: string) {
    const cronstrueOptions = {
        use24HourTimeFormat: true,
        throwExceptionOnParseError: false
    };
    return cronstrue.toString(cronstrueExpression, cronstrueOptions);
}

export function formatChangeValue(value: ChangeAttributeValue) {
    if (value === null)
        return '{null}';
    else if (value === '')
        return '{empty}';
    else
        return value;
}
